import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { IItem } from "src/domain/entities"
import { itemDeleteService } from "src/domain/services/item/itemDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"

interface Props {
	item: IItem
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const ItemDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	item,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleItemDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await itemDeleteService({ id: item.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [item, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Item: ${item.name}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleItemDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
